import { render } from "./Order_management.vue?vue&type=template&id=66b1c269&scoped=true"
import script from "./Order_management.vue?vue&type=script&lang=js"
export * from "./Order_management.vue?vue&type=script&lang=js"

import "./Order_management.vue?vue&type=style&index=0&id=66b1c269&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b1c269"]])

export default __exports__